// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "banner-3GaKU";
var _4 = "title-2qkp5";
var _5 = "isPopular-3QlgJ";
var _6 = "icons-sZGsb";
var _7 = "popularBadge-2UCCR";
var _8 = "withTitle-XO8f7";
var _9 = "tip-2Udgv";
var _a = "badge-2lpWJ";
export { _1 as "__esModule", _2 as "mobile", _3 as "banner", _4 as "title", _5 as "isPopular", _6 as "icons", _7 as "popularBadge", _8 as "withTitle", _9 as "tip", _a as "badge" }
export default { "__esModule": _1, "mobile": _2, "banner": _3, "title": _4, "isPopular": _5, "icons": _6, "popularBadge": _7, "withTitle": _8, "tip": _9, "badge": _a }
